import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ContactModal from './ContactModal';
import LanguageSwitcher from './LanguageSwitcher';

type HeaderActionsProps = {
  scale?: number;
  stackOnMobile?: boolean;
  orientation?: 'row' | 'column';
  fullWidth?: boolean;
  className?: string;
};

export default function HeaderActions({
  scale = 1,
  stackOnMobile = false,
  orientation = 'row',
  fullWidth = false,
  className = '',
}: HeaderActionsProps) {
  const { t } = useTranslation();
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const isColumn = orientation === 'column';

  return (
    <>
      <div
        className={[
          'flex',
          isColumn ? 'flex-col items-stretch gap-4' : stackOnMobile ? 'flex-col items-stretch gap-3 sm:flex-row sm:items-center' : 'items-center gap-3',
          className,
        ]
          .filter(Boolean)
          .join(' ')}
      >
        <div className={fullWidth ? 'w-full' : ''}>
          <LanguageSwitcher scale={scale} fullWidth={fullWidth} />
        </div>
        <button
          type="button"
          onClick={() => setIsContactModalOpen(true)}
          className={`inline-flex rounded-full bg-brand-green px-5 py-2.5 text-sm font-semibold text-[#0D0D0D] transition-all hover:bg-[#b8f05a] cursor-pointer whitespace-nowrap shadow-[0_12px_30px_rgba(163,230,53,0.25)] ${fullWidth ? 'w-full justify-center' : ''}`}
          style={{ transform: `scale(${scale})`, transformOrigin: 'center right' }}
        >
          {t('nav.contactCta')}
        </button>
      </div>

      <ContactModal
        isOpen={isContactModalOpen}
        onClose={() => setIsContactModalOpen(false)}
        presetService={null}
        showBudget={false}
      />
    </>
  );
}
